var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_box"},[_c('p',{staticClass:"table_title_box"},[_c('span',{staticClass:"table_title_text"},[_vm._v(_vm._s(_vm.title))])]),(_vm.button)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.button))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }